import { preload } from '@ms/office-web-host';
import { isFeatureEnabled } from 'owa-feature-flags';

let isFluidPreloaded: boolean = false;

export function isPreloadFluidInCollabSpaceComplete() {
    return isFluidPreloaded;
}

export function preloadFluidInCollabSpace() {
    preload({
        isolationConfig:
            isFeatureEnabled('cmp-fluid-sourcelessIFrame') ||
            isFeatureEnabled('cmp-fluid-sourcelessIFrameAlways')
                ? undefined
                : {
                      useIframe: true,
                  },
    });

    isFluidPreloaded = true;
}
